import { render } from "./GeneralSurgery.vue?vue&type=template&id=0a02c965"
import script from "./GeneralSurgery.vue?vue&type=script&lang=ts"
export * from "./GeneralSurgery.vue?vue&type=script&lang=ts"
script.render = render

export default script